import { match } from 'ts-pattern'
import i18next from 'i18next'
import type { CustomFieldChoiceMutator } from '@/lib/entity/custom_field_choice'
import type { Converter } from '@/lib/converter/entityFormatter'
import { layered } from '@/lib/layered'
import type { Kysely } from 'kysely'
import type { DB } from '@/lib/kysely-d'
import { sql } from 'kysely'
import { asModifiedField } from '@/lib/converter/entityFormatter'

type CustomFieldChoiceSchema = CustomFieldChoiceMutator['merged']

export const CustomFieldChoiceConverter: Converter<CustomFieldChoiceSchema> = {
  icon: () => i18next.t('stages.icon.custom_field_choice'),
  title: () => i18next.t('stages.table.custom_field_choice'),
  subTitle: async (merged) => {
    const queryResult = await customFieldChoiceQuery(merged.id!)
    const subTitle = queryResult.nameConcat
    return subTitle.merged() ?? subTitle.get('BASE') ?? ''
  },
  modifiedFields: (modified, column) => {
    const label = i18next.t(`stages.labels.custom_field_choice.${column}`)
    return match(column)
      .with('name', 'key', 'visible', (column) => asModifiedField(label, modified[column]!))
      .with('id', 'custom_field_id', 'order', () => undefined)
      .exhaustive()
  }
}

const customFieldChoiceQuery = async (id: string) => {
  return await layered(async (db: Kysely<DB>) => {
    const result = await db
      .selectFrom('custom_field')
      .innerJoin('custom_field_choice', 'custom_field_choice.custom_field_id', 'custom_field.id')
      .select([
        sql<string>`custom_field.name || ' x ' || custom_field_choice.name`.as('nameConcat')
      ])
      .where('custom_field_choice.id', '=', id)
      .executeTakeFirst()
    if (!result) {
      return { nameConcat: null }
    }
    return result
  })
}
